import React, { useEffect, useState } from "react";
import Layout from "../../../components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import ToastFile from "../../../utils/ToastFile";
import { updateTaskLog } from "../../../api/TaskApi";
import moment from "moment";
import ButtonLoader from "../../../components/ButtonLoader";

const UpdateMyTask = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isActionEdit, setIsActionEdit] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [isLoading, setIsloading] = useState(false);

  useEffect(() => {
    if (state?.mode === "Edit") {
      setIsActionEdit(true);
      reset(state?.taskLog);
    } else {
      setIsActionEdit(false);
      reset(state?.taskLog);
    }
  }, []);

  const navigationToBack = () => {
    if(state?.from === "task"){
      navigate("/mytask");
    }else{
      navigate("/taskhistory");
    }
  }

  const onSubmit = (data) => {
    setIsloading(true);
    let payload = {
      ...data,
      date: data.date ? moment(new Date(data.date)).format("YYYY-MM-DD") : null,
      startTime: data.startTime
        ? new Date(`1970-01-01T${data.startTime}:00`)
        : null,
      endTime: data.endTime ? new Date(`1970-01-01T${data.endTime}:00`) : null,
      employee: user.id,
      tenant_id: state?.taskLog.tenant_id,
      status: state?.taskLog.status,
      createdBy: state?.taskLog.createdBy,
      createdAt: state?.taskLog.createdAt,
      modifiedBy: user.user_id,
      modifiedAt: new Date(),
      isApproved: ""
    };
    if (isActionEdit) {
      updateTaskLog(state?.taskLog?._id, payload)
        .then((res) => {
          setIsloading(false);
          if (res.status === 200) {
            ToastFile("Task updated successfully", "updated");
            reset();
            navigationToBack()
          } else {
            ToastFile("Failed to update task", "error");
          }
        })
        .catch((err) => {
          setIsloading(false);
          console.error("Error updating task:", err);
          ToastFile("Error updating task", "error");
        });
    } else {
      setIsloading(false);
      navigationToBack()
    }
  };

  const {
    register,
    control,
    watch,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const claimHours = watch("claimHours");
  const payrate = watch("payrate");
  const fuelCost = watch("fuelCost");

  useEffect(() => {
    const hours = parseFloat(claimHours) || 0;
    const rate = parseFloat(payrate) || 0;
    const fuel = parseFloat(fuelCost) || 0;

    const total = hours * rate + fuel;
    setValue("totalCost", total.toFixed(2));
  }, [claimHours, payrate, fuelCost, setValue]);

  return (
    <Layout>
      <div className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="mb-0">
            {" "}
            {isActionEdit ? state?.from === "taskhistory" ? "Update Task" : "Finish Task" : "Task Details"}
          </h3>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3">
            <Form.Label>Task Category</Form.Label>
            <Form.Control
              type="text"
              disabled={true}
              {...register("category", { required: false })}
              isInvalid={errors.category}
            />
          </Form.Group>
          {/* <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              disabled={true}
              {...register("description", { required: false })}
              isInvalid={errors.description}
            />
            </Form.Group>
            <Form.Group className="mb-3">
            <Form.Label>Work Type</Form.Label>
            <Form.Control
              type="text"
              disabled={true}
              {...register("workType", { required: false })}
              isInvalid={errors.workType}
            />
          </Form.Group> */}
          <Form.Group className="mb-3">
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="date"
              //disabled={true}
              {...register("date", { required: false })}
              isInvalid={errors.date}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Start Time</Form.Label>
            <Form.Control
              type="time"
              disabled={!isActionEdit}
              {...register("startTime", { required: false })}
              isInvalid={errors.startTime}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>End Time</Form.Label>
            <Form.Control
              type="time"
              disabled={!isActionEdit}
              {...register("endTime", { required: false })}
              isInvalid={errors.endTime}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Claim Hours / No of Parcels</Form.Label>
            <Form.Control
              type="text"
              disabled={!isActionEdit}
              {...register("claimHours", { required: true })}
              isInvalid={errors.claimHours}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Pay Rate / Per Parcel Cost</Form.Label>
            <Form.Control
              type="text"
              {...register("payrate", { required: true })}
              isInvalid={errors.payrate}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Fuel Cost ($)</Form.Label>
            <Form.Control
              type="text"
              disabled={!isActionEdit}
              {...register("fuelCost", { required: false })}
              isInvalid={errors.fuelCost}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Total Cost ($)</Form.Label>
            <Form.Control
              type="text"
              disabled={true}
              {...register("totalCost", { required: false })}
              isInvalid={errors.totalCost}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Comment (optional)</Form.Label>
            <Form.Control
              as="textarea"
              disabled={!isActionEdit}
              rows={3}
              {...register("comment", { required: false })}
              isInvalid={errors.comment}
            />
          </Form.Group>
          <Button variant="primary" type="submit" style={{minWidth:'98px'}}>
            {isLoading ? <ButtonLoader width="20px" height="20px"/>  : isActionEdit ? "Complete" : "Done"}
          </Button>
          <Button
            variant="white"
            className="border-1 border-dark ms-2"
            onClick={() => navigationToBack()}
          >
            Cancel
          </Button>
        </Form>
      </div>
    </Layout>
  );
};

export default UpdateMyTask;
